<div class="container-fluid h-100 d-flex justify-content-center align-items-center flex-column login-container">
  <div class="row justify-content-center mt-5 mb-3">
    <img *ngIf="domain?.logoUrl" class="navbar-brand__img-l login-logo" [attr.src]="domain?.logoUrl" alt="Brand Logo"/>
  </div>
  <div class="login-content login-toastr-container">
    <div class="toastr-relative toastr-sm toastr-no-shadow mb-1" toastContainer></div>
  </div>
  <div class="row" *ngIf="show && !gologin">
    <div class="col">
      <div class="card card-login pb-2 login-content">
        <div class="card-body">
          <form  class="form" role="form" (ngSubmit)="submit()" [formGroup]="resetForm">
            <div class="form-group">
              <label for="newPassword" translate>change_password_new</label>
              <input type="newPassword" class="form-control" name="newPassword" id="newPassword" placeholder="Password"
                     formControlName="newPassword">
              <wsb-validation-error-msg [fc]="resetForm.get('newPassword')"></wsb-validation-error-msg>
            </div>
            <div class="form-group">
              <label for="confirmNewPassword" translate>change_password_repeat</label>
              <input type="confirmNewPassword" class="form-control" name="confirmNewPassword" id="confirmNewPassword" placeholder="Password"
                     formControlName="confirmNewPassword">
              <wsb-validation-error-msg [fc]="resetForm.get('confirmNewPassword')"></wsb-validation-error-msg>
            </div>
            <div class="row">
              <div class="col-12">
                <wsb-atlas-button class="float-right" [loading]="loading" [label]="'reset_resetbtn'" [roundButton]="true" buttonType="submit"></wsb-atlas-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div   *ngIf="gologin" >
    <div class="row">
      <div class="col-12">
        <wsb-atlas-button class="float-right" [label]="'back_login'" [roundButton]="true" (click) = "goLogin()"></wsb-atlas-button>
      </div>
    </div>
  </div>
</div>
